import {TFunction} from 'react-i18next';

type IsFieldRequired = (name: string) => boolean;

const getRequiredFlag = (isFieldRequired?: IsFieldRequired) => (name: string, fallback = false) =>
    isFieldRequired ? isFieldRequired(name) : fallback;

export const valueIsDecNumberWithEmpty = (value: string) => {
    const num = Number(value);
    return !isNaN(num);
};
const GEN_INFO = 'pages.documents.invoices.create.taxesTotal';
export const formData = (
    t: TFunction<'translation'>,
    doesInvoiceExist: boolean,
    isFieldRequired?: IsFieldRequired,
) => ({
    charges: [
        {
            type: 'input',
            label: t(`${GEN_INFO}.charges.lineExtensionAmount.label`),
            placeholder: t(`${GEN_INFO}.charges.lineExtensionAmount.placeholder`),
            name: 'lineExtensionAmount',
            required: getRequiredFlag(isFieldRequired)('lineExtensionAmount'),
            disabled: true,
        },
        {
            type: 'input',
            label: t(`${GEN_INFO}.charges.taxExclusiveAmount_1.label`),
            placeholder: t(`${GEN_INFO}.charges.taxExclusiveAmount_1.placeholder`),
            name: 'taxExclusiveAmountDisplay',
            required: getRequiredFlag(isFieldRequired)('taxExclusiveAmountDisplay'),
            disabled: true,
        },
        {
            type: 'input',
            label: t(`${GEN_INFO}.charges.taxExclusiveAmount_2.label`),
            placeholder: t(`${GEN_INFO}.charges.taxExclusiveAmount_2.placeholder`),
            name: 'taxInclusiveAmountDisplay',
            required: getRequiredFlag(isFieldRequired)('taxInclusiveAmountDisplay'),
            disabled: true,
        },
        {
            type: 'input',
            label: 'Allowance Total Amount',
            placeholder: 'Allowance Total Amount',
            name: 'allowanceTotalAmountDisplay',
            required: getRequiredFlag(isFieldRequired)('allowanceTotalAmountDisplay'),
            disabled: true,
        },
        {
            type: 'input',
            label: 'Charge Total Amount',
            placeholder: 'Charge Total Amount',
            name: 'chargeTotalAmountDisplay',
            required: getRequiredFlag(isFieldRequired)('chargeTotalAmountDisplay'),
            disabled: true,
        },
        {
            type: 'input',
            label: t(`${GEN_INFO}.charges.amountDueForPayment.label`),
            placeholder: t(`${GEN_INFO}.charges.amountDueForPayment.placeholder`),
            name: 'prepaidAmount',
            rawType: 'number',
            numberSteps: '0.01',
            required: getRequiredFlag(isFieldRequired)('prepaidAmount'),
            disabled: doesInvoiceExist,
        },
        {},
        {
            type: 'input',
            label: t(`${GEN_INFO}.charges.roundingAmount.label`),
            placeholder: t(`${GEN_INFO}.charges.roundingAmount.placeholder`),
            name: 'payableRoundingAmount',
            rawType: 'number',
            numberSteps: '0.01',
            required: getRequiredFlag(isFieldRequired)('payableRoundingAmount'),
            disabled: doesInvoiceExist,
        },
        {
            type: 'input',
            label: t(`${GEN_INFO}.charges.payableAmount.label`),
            placeholder: t(`${GEN_INFO}.charges.payableAmount.placeholder`),
            name: 'payableAmountDisplay',
            required: getRequiredFlag(isFieldRequired)('payableAmountDisplay'),
            disabled: true,
        },
    ],
});
